/**
 * What environment setups we use for the BE applications
 */
export enum UsedEnvironments {
  Prod = "prod",
  Dev = "dev"
}